
import React, { useState } from 'react'

import { removeResponsible } from '@/Services/ProgrammationManagerService';
import { useProgrammation } from '@/Hooks/UseProgrammation';

import UserAvatar from '@/Components/UserAvatar/UserAvatar';

import Spinner from '@/Components/SvgImages/Spinner/Spinner';
import TrashIcon from '../../SvgImages/TrashIcon';

import './ResponsibleItem.scss'
import { useDispatch } from 'react-redux';
import { updateResponsiblesAction } from '@/Redux/Actions/ProgrammationManagerActions';

interface Props {
  user: any
  subTask?: any
  canDelete?: boolean
  onDeleted: () => void
}

const ResponsibleItem = ({ user, subTask, canDelete = true, onDeleted }: Props) => {

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const dispatch = useDispatch()

  const [ deleting, setDeleting ] = useState(false)

  const task = subTask || itemOpened

  const handleDelete = async () => {

    setEditingItem(true)
    setDeleting(true)

    const [ error, data ] = await removeResponsible(task._id, user._id)

    setDeleting(false)
    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    if (!subTask) {

      patchItemOpened({
        responsibles: itemOpened.responsibles.filter((u: any) => u._id !== user._id)
      })
    } else {

      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.responsibles = subTask.responsibles.filter((u: any) => u._id !== user._id)
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateResponsiblesAction({ task: data.task, parentTask: data.parentTask }))

    onDeleted()
  }

  return (
    <div className="responsible-item">
      <div className="responsible-item-avatar">
        <UserAvatar user={user} size="sm" />
      </div>
      <div className="responsible-item-content">
        {user.name} {user.surname}
      </div>
      <div className="responsible-item-actions">
        {canDelete && (
          <button
            className="responsible-item-delete"
            onClick={handleDelete}
            disabled={deleting}
            >
            {deleting && (
              <Spinner
                height={20}
                width={20}
              />
            )}
            {!deleting && (
              <TrashIcon
                height={20}
                width={20}
                color="#333"
              />
            )}
          </button>
        )}
      </div>
    </div>
  )
}

export default ResponsibleItem
